<template>
  <details class="mt-3">
    <summary>
      {{ t("backend.e2e.voting_round_reports.show.external_votes") }}
    </summary>
    <ul class="list-group border-0">
      <li
        v-for="optionTitle in Object.keys(externalVotes)"
        :key="`external_vote_${optionTitle}`"
        class="list-group-item d-flex justify-content-between align-items-center"
      >
        {{ optionTitle }}
        <template v-if="typeof(externalVotes[optionTitle]) == 'object'">
          <div class="w-25">
            <ul class="list-group">
              <li
                v-for="rank in Object.keys(externalVotes[optionTitle])"
                :key="`external_vote_rank_${rank}`"
                class="border-0 list-group-item d-flex justify-content-between w-100"
              >
                {{ t("backend.e2e.voting_round_reports.show.rank_n", {
                    rank: parseInt(rank) + 1
                  }) }}: {{  externalVotes[optionTitle][rank] }}
              </li>
            </ul>
          </div>
        </template>

        <template v-else>
          <span>{{ externalVotes[optionTitle] }}</span>
        </template>
      </li>
    </ul>
  </details>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { PropType } from "@/types";

const { t } = useI18n();

defineProps({
  externalVotes: {
    type: Object as PropType<Record<string, number | Record<string, number>>>,
    required: true,
  },
})
</script>
